var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/search-normal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search-normal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.502 21.7492C5.85195 21.7492 1.25195 17.1492 1.25195 11.4992C1.25195 5.84921 5.85195 1.24921 11.502 1.24921C17.152 1.24921 21.752 5.84921 21.752 11.4992C21.752 17.1492 17.152 21.7492 11.502 21.7492ZM11.502 2.74921C6.67195 2.74921 2.75195 6.67921 2.75195 11.4992C2.75195 16.3192 6.67195 20.2492 11.502 20.2492C16.332 20.2492 20.252 16.3192 20.252 11.4992C20.252 6.67921 16.332 2.74921 11.502 2.74921Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.9995 22.7491C21.8095 22.7491 21.6195 22.6791 21.4695 22.5291L19.4695 20.5291C19.1795 20.2391 19.1795 19.7591 19.4695 19.4691C19.7595 19.1791 20.2395 19.1791 20.5295 19.4691L22.5295 21.4691C22.8195 21.7591 22.8195 22.2391 22.5295 22.5291C22.3795 22.6791 22.1895 22.7491 21.9995 22.7491Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.53ada9742840593dd2597e4be8089c29.svg";
export { ForwardRef as ReactComponent };